import type {
    NeglectedOrDelinquentStudentCharacteristicsModel,
} from './NeglectedOrDelinquentInformationModel';

export const STUDENT_CHARACTERISTIC_FIELDS: {
    key: keyof NeglectedOrDelinquentStudentCharacteristicsModel;
    label: string;
}[] = [
    { key: 'disabilitySpecialEducation', label: 'Disability / Special Education' },
    { key: 'englishLanguageLearner', label: 'English Language Learner' },
    { key: 'homeless', label: 'Homeless' },
    { key: 'unaccompaniedHomelessYouth', label: 'Unaccompanied Homeless Youth' },
    { key: 'immigrant', label: 'Immigrant' },
    { key: 'migrant', label: 'Migrant' },
];
